import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
// import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import * as actions from '../actions';

function ViewPaymentLogs({ logs }) {
  return (
    <Modal.Body>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          marginBottom: '20px',
          overflow: 'auto',
        }}
      >
        {/* <Tabs>
          <TabList>
            <Tab>Payment Logs</Tab>
            <Tab>Payment Status</Tab>
          </TabList>
          <TabPanel> */}
        <div style={{ height: '600px', width: '100%', overflow: 'auto' }}>
          <div className="table-responsive p-3" style={{ width: '200%' }}>
            <table className="table table-striped table-sm table-bordered table-hover">
              <thead className="table-header">
                <tr>
                  <th className="p-2">#</th>
                  <th className="p-2">NAME</th>
                  <th className="p-2">TXNID</th>
                  <th className="p-2">REFNO</th>
                  <th className="p-2">AMOUNT</th>
                  <th className="p-2">PGI URL GENERATED AT</th>
                  <th className="p-2">PENDING AT</th>
                  <th className="p-2">TRANSACTION STATUS</th>
                  <th className="p-2">PAYMENT STATUS</th>
                  <th className="p-2">REMARKS</th>
                  <th className="p-2">PAYMENT CHANNEL</th>
                  <th className="p-2">BRANCH</th>
                </tr>
              </thead>
              <tbody className="table-details">
                {logs.map((data) => (
                  <tr key={_.get(data, 'id')}>
                    <td>{_.get(data, 'id')}</td>
                    <td>{_.get(data, 'attributes.name') || 'N/A'}</td>
                    <td>{_.get(data, 'attributes.txnid') || 'N/A'}</td>
                    <td>{_.get(data, 'attributes.refno') || 'N/A'}</td>
                    <td>{_.get(data, 'attributes.amount') || 'N/A'}</td>
                    <td>
                      {_.get(data, 'attributes.pgi_url_generated_at') || 'N/A'}
                    </td>
                    <td>{_.get(data, 'attributes.pending_at') || 'N/A'}</td>
                    <td>
                      {_.get(data, 'attributes.transaction_status') || 'N/A'}
                    </td>
                    <td>{_.get(data, 'attributes.status') || 'N/A'}</td>
                    <td>{_.get(data, 'attributes.remarks') || 'N/A'}</td>
                    <td>
                      {_.get(data, 'attributes.payment_channel') || 'N/A'}
                    </td>
                    <td>{_.get(data, 'attributes.payment_branch') || 'N/A'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        {/* </TabPanel>
          <TabPanel>
            <div className="p-3">
              <div className="table-responsive" style={{ width: '100%' }}>
                <table className="table table-striped table-sm table-bordered table-hover">
                  <thead className="table-header">
                    <tr>
                      <th className="p-2">TRANSACTION ID</th>
                      <th className="p-2">MPAY STATUS</th>
                    </tr>
                  </thead>
                  <tbody className="table-details">
                    {paymentLogs.map((data, i) => (
                      <tr
                        // eslint-disable-next-line react/no-array-index-key
                        key={`logs-${i}`}
                      >
                        <td>{_.get(data, 'txnid') || 'N/A'}</td>
                        <td>{_.get(data, 'status') || 'N/A'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </TabPanel>
        </Tabs> */}
      </div>
    </Modal.Body>
  );
}

ViewPaymentLogs.propTypes = {
  logs: PropTypes.instanceOf(Object).isRequired,
  // paymentLogs: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ViewPaymentLogs);
